import OrderMethodStep from "./OrderMethodStep";
import PersonalInfoStep from "./PersonalInfoStep";
import PhoneNumberStep from "./PhoneNumberStep";
import ReceiptInfoStep from "./ReceiptInfoStep";
import SelectPaymentMethodStep from "./SelectPaymentMethodStep";

export default {
  OrderMethodStep,
  PersonalInfoStep,
  PhoneNumberStep,
  ReceiptInfoStep,
  SelectPaymentMethodStep,
};
